var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSensibull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 540,
    viewBox: "0 0 518 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.765 26.5125C413.913 50.8803 453.406 97.218 479.965 151.344C507.667 207.8 531.32 272.243 507.996 330.644C484.903 388.465 418.277 407.239 364.939 439.357C298.716 479.233 240.33 552.825 164.575 537.435C84.4326 521.154 20.5031 445.562 2.63897 365.757C-13.4392 293.93 49.4582 234.747 82.0463 168.75C109.403 113.347 120.088 44.8567 175.043 16.6093C231.747 -12.5374 300.448 0.744138 358.765 26.5125Z",
    fill: "url(#paint0_linear_1278_253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1278_253",
    x1: 366.765,
    y1: 28.986,
    x2: 171.603,
    y2: 542.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B0EF",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F7E1",
    stopOpacity: 0.49
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensibull);
export default __webpack_public_path__ + "static/media/sensibull.1131dd1ca44cfdb65ddbc06899105af7.svg";
export { ForwardRef as ReactComponent };